import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ProjectCard from '../../components/common/ProjectCard';
import SEO from '../../components/common/SEO';
import { supabase } from '../../config/supabase';

const Spenden = () => {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const { data, error } = await supabase
          .from('donation_projects')
          .select('*')
          .order('created_at', { ascending: false });

        if (!error && data) {
          setProjects(data);
        }
      } catch (err) {
        console.error('Error fetching projects:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <div className="py-12 bg-gray-50 min-h-screen">
      <SEO
        title={t('seo.spendenTitle')}
        description={t('seo.spendenDescription')}
      />

      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {t('spenden.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('spenden.subtitle')}
          </p>
        </div>

        {loading ? (
          <div className="text-center py-12">
            <p className="text-gray-500">{t('common.loading')}</p>
          </div>
        ) : projects.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500">{t('spenden.noProjects')}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project) => (
              <ProjectCard
                key={project.id}
                title={project.title}
                description={project.description}
                category={project.category}
                status={project.status}
                image={project.image}
              />
            ))}
          </div>
        )}

        <div className="mt-12 text-center">
          <Link
            to="/contact"
            className="inline-block bg-primary-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-primary-700 transition-colors"
          >
            {t('spenden.donateNow')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Spenden;
